<div fxLayout="row">
  <mat-label [ngStyle]="captionStyles()">
    {{ question.Caption | qnaTranslate }}
    @if (question.IsRequired) {
    <mat-label class="color-city-red"> *</mat-label>
    }
  </mat-label>
</div>

<mat-radio-group
  [(ngModel)]="selectedOption"
  (ngModelChange)="onOptionSelected(selectedOption)"
>
  @for (option of options; track option; let i = $index) {
  <div fxLayout="column">
    <div fxLayout="row" class="radio-row">
      <div fxLayout="column">
        <mat-radio-button
          [value]="option"
          name="questionOption{{ question.Id }}"
        >
        </mat-radio-button>
      </div>
      <div
        fxFlex="80"
        fxLayout="column"
        fxLayoutAlign="center start"
        [ngStyle]="questionDetailsStyles()"
      >
        <span class="checkbox-textwrap color-dark-blue font-size-body-text">
          {{ translatedOption[i] }}
        </span>
      </div>
    </div>
    @if (selectedOption === option && nextQuestions) {
    <div fxLayout="row">
      <div fxFlex="100" fxLayout="column">
        @for (nextQuestion of nextQuestions; track nextQuestion) {
        <div class="rules-render">
          <app-permit-question-render
            [question]="nextQuestion"
            [hasContentError]="nextQuestion.hasContentError"
          ></app-permit-question-render>
        </div>
        }
      </div>
    </div>
    }
  </div>
  }
</mat-radio-group>

@if (question.HasContentError && question.IsRequired && !question.Answer) {
<div>
  <mat-error>{{ isRequiredMessageDisplay }}</mat-error>
</div>
}
